<template>
  <div class="block">
    <kst-output field="Name" :data="data" :catalog="Catalog"/>
    <kst-output field="Alias" :data="data" :catalog="Catalog"/>
    <kst-output field="DaysDueDate" :data="data" :catalog="Catalog"/>
    <kst-output field="Mobile" :data="data" :catalog="Catalog"/>
    <kst-output field="Phone" :data="data" :catalog="Catalog"/>
    <kst-output field="Email" :data="data" :catalog="Catalog"/>
    <kst-output field="Comment" :data="data" :catalog="Catalog"/>
    <kst-created :data="data"/>
    <kst-last-updated :data="data"/>
  </div>
</template>

<script>
import Catalog from "../CliCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>